export default "__VITE_ASSET__Bh8RS_x8__"